
export default function reducer(
  state = {
    status: "",
    error: null,
    actives: {
      data: {
        byid: {},
        list: [],
      },
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      }
    },
    archived: {
      data: {
        byid: {},
        list: [],
      },
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      }
    },
    reports_new: 0,
    reports_today: 0
  },
  action
) {
  let data
  switch (action.type) {
    case "CLEAR_STORE":
      state = defaultState()
      break;
    case "REPORTS_STATISTICS_COUNT":
      data = action.payload.data
      state = {
        ...state,
        error: null,
        status: "REPORTS_STATISTICS_COUNT",
        reports_new: data.reports_new,
        reports_today: data.reports_today
      }
      break;
    case "REPORTS_STATISTICS_FULFILLED":
      data = action.payload.data
      state = {
        ...state,
        error: null,
        status: "REPORTS_STATISTICS_FULFILLED",
        reports_new: data.new,
        reports_today: data.today
      }
      break;
    case "REPORTS_ACTIVE_FULFILLED":
      state = _reports_active_fulfilled(state, action.payload.data)
      break;
    case "REPORTS_ACTIVES_ITEMPERPAGE":
      state = _reports_actives_itemperpage(state, action.payload.count)
      break;
    case "REPORTS_ACTIVE_CURRENTPAGE":
      state = _reports_actives_currentPage(state, action.payload.page)
      break;
    case "REPORTS_ACTIVE_NEW":
      state = _reports_actives_new(state)
      break;
    case "REPORTS_READ_FULFILLED":
      state = _reports_read_fulfilled(state, action.payload.data)
      break;
    case "REPORTS_ARCHIVE_FULFILLED":
      state = _reports_archive_fulfilled(state, action.payload.data)
      break;
    case "REPORTS_UNREAD_FULFILLED":
      state = _reports_unread_fulfilled(state, action.payload.data)
      break;
    case "REPORTS_ACTION_NEW":
      state = _reports_action_new(state, action.payload.data)
      break;
    case "REPORTS_ARCHIVED_FULFILLED":
      state = _reports_archived_fulfilled(state, action.payload.data)
      break;
    case "REPORTS_ARCHIVED_ITEMPERPAGE":
      state = _reports_archived_itemperpage(state, action.payload.count)
      break;
    case "REPORTS_ARCHIVED_CURRENTPAGE":
      state = _reports_archived_currentPage(state, action.payload.page)
      break;
    case "REPORTS_UNARCHIVED_FULFILLED":
      state = _reports_unarchived_fulfilled(state, action.payload.data)
      break;
    default:
      return state;
  }
  return state;
}

function defaultState() {
  return {
    status: "",
    error: null,
    actives: {
      data: {
        byid: {},
        list: [],
      },
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      }
    },
    archived: {
      data: {
        byid: {},
        list: [],
      },
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      }
    },
    reports_new: 0,
    reports_today: 0
  }
}
function _reports_active_fulfilled(state, info) {

  let i = __reports_active_normalized(info)
  let { actives, ..._state } = state
  let { data, pagination, ..._actives } = actives

  let pCount = Math.ceil(i.total / pagination.itemPerPage);
  if (pCount < 1) pCount = 1;
  pagination = {
    ...pagination,
    count: i.total,
    total: i.total,
    pageCount: pCount
  }

  let { byid, list, ..._data } = data

  let _byid = { ...byid, ...i.reports.byid }

  let _list = [...list]
  if (list.length < 1 || pagination.total !== i.total) {
    _list = new Array(pagination.total).fill(-1)
  }
  _list.splice(i.skip, i.reports.list.length, ...i.reports.list)

  _data = { ..._data, byid: _byid, list: _list }
  _actives = { ..._actives, data: _data, pagination: pagination }
  _state = { ..._state, actives: _actives }

  return _state
}
function _reports_actives_itemperpage(state, count) {
  let { actives, ..._state } = state
  let { pagination, ..._actives } = actives

  let pCount = Math.ceil(pagination.total / count);
  if (pCount < 1) pCount = 1;
  let _pagination = {
    ...pagination,
    itemPerPage: count,
    pageCount: pCount,
    currentPage: 1
  }

  _actives = {
    ..._actives,
    pagination: _pagination
  }
  _state = {
    ..._state,
    actives: _actives
  }
  return _state
}
function _reports_actives_currentPage(state, page) {
  let { actives, ..._state } = state
  let { pagination, ..._actives } = actives
  let _pagination = {
    ...pagination,
    currentPage: page
  }

  _actives = {
    ..._actives,
    pagination: _pagination
  }
  _state = {
    ..._state,
    actives: _actives
  }
  return _state
}
function _reports_actives_new(state) {
  let { actives, ..._state } = state
  let { data, pagination, ..._actives } = actives
  let { list, ..._data } = data
  let { pageCount, total, ..._pagination } = pagination

  total = total + 1
  pageCount = Math.ceil(total / pagination.itemPerPage);
  if (pageCount < 1) pageCount = 1;

  _pagination = { ..._pagination, pageCount: pageCount, total: total }

  list.splice(0, 0, -1);
  _data = { ..._data, list: list }

  _actives = { ..._actives, data: _data, pagination: _pagination }
  _state = { ..._state, actives: _actives }

  return _state
}
function _reports_read_fulfilled(state, info) {

  if (state.actives.data.byid[`${info.report.id}`]) {
    let rptid = info.report.id
    let newCount = info.count_new

    let { actives, ..._state } = state
    let { data, ..._actives } = actives
    let { byid, ..._data } = data
    let { [`${rptid}`]: rpt, ..._byid } = byid

    let _msg = { ...rpt, isRead: true }

    _byid = { ..._byid, [rptid]: _msg }
    _data = { ..._data, byid: _byid }
    _actives = { ..._actives, data: _data }
    _state = { ..._state, actives: _actives, reports_new: newCount }

    return _state
  }

  if (state.archived.data.byid[`${info.report.id}`]) {
    let rptid = info.report.id
    let newCount = info.count_new

    let { archived, ..._state } = state
    let { data, ..._archived } = archived
    let { byid, ..._data } = data
    let { [`${rptid}`]: rpt, ..._byid } = byid

    let _msg = { ...rpt, isRead: true }

    _byid = { ..._byid, [rptid]: _msg }
    _data = { ..._data, byid: _byid }
    _archived = { ..._archived, data: _data }
    _state = { ..._state, archived: _archived, reports_new: newCount }

    return _state
  }

  return state;
}
function _reports_archive_fulfilled(state, info) {
  let rptId = info.report.id
  let { actives, ..._state } = state
  let { data, pagination, ..._actives } = actives
  let { byid, list, ..._data } = data

  if (typeof (byid[rptId]) === 'undefined') {
    return state
  }

  /*eslint-disable no-unused-vars*/
  let { [`${rptId}`]: rpt, ..._byid } = byid
  /*eslint-enable no-unused-vars*/
  let _list = list.filter(e => e !== rptId)
  _data = { ..._data, byid: _byid, list: _list }

  let total = pagination.total - 1
  let pageCount = Math.ceil(total / pagination.itemPerPage)
  if (pageCount < 1) pageCount = 1;

  let currentPage = pagination.currentPage
  if (currentPage > pageCount) {
    currentPage = pageCount
  }
  let _pagination = {
    ...pagination,
    currentPage: currentPage,
    pageCount: pageCount,
    total: pagination.total - 1
  }

  _actives = { ..._actives, data: _data, pagination: _pagination }
  _state = { ..._state, actives: _actives }
  _state = updateArchive(_state);
  return _state
}
function updateArchive(state) {
  let { archived, ..._state } = state
  let { data, pagination, ..._archived } = archived
  let { byid, list, ..._data } = data

  if (list.length < 1) {
    return state;
  }

  let pageCount = Math.ceil((pagination.total + 1) / pagination.itemPerPage);
  if (pageCount < 1) {
    pageCount = 1;
  }
  pagination = {
    ...pagination,
    count: pagination.count + 1,
    total: pagination.total + 1,
    pageCount: pageCount
  }

  byid = {};
  let _list = list.map(e => {
    if (e !== -1) {
      return -1;
    }
    return -1;
  });
  _list.push(-1);

  _data = {
    ..._data,
    byid: byid,
    list: _list
  }
  _archived = {
    ..._archived,
    data: _data,
    pagination: pagination
  }
  _state = {
    ..._state,
    archived: _archived
  }
  return _state;
}

function _reports_unread_fulfilled(state, info) {
  let rptId = info.report.id
  if (typeof (state.actives.data.byid[rptId]) === 'undefined') {
    return state
  }

  let { actives, ..._state } = state
  let { data, ..._actives } = actives
  let { byid, ..._data } = data
  let { [`${rptId}`]: rpt, ..._byid } = byid

  let _rpt = {
    ...rpt,
    isRead: false
  }

  _byid = { ..._byid, [`${rptId}`]: { ..._rpt } }
  _data = { ..._data, byid: _byid }
  _actives = { ..._actives, data: _data }
  _state = { ..._state, actives: _actives, reports_new: info.count_new }

  return _state
}
function _reports_action_new(state, info) {
  //console.log("_reports_action_new", info);

  if (typeof (state.actives.data.byid[`${info.reportId}`]) === 'undefined') { return state }

  let isDuplicate = state.actives.data.byid[`${info.reportId}`].actions.find((a) => {
    return (a.id === info.id)
  })
  if (isDuplicate) {
    return state
  }

  let { actives, ..._state } = state
  let { data, ..._actives } = actives
  let { byid, ..._data } = data
  let { [`${info.reportId}`]: rid, ..._byid } = byid
  let { actions, ..._rid } = rid


  let _actions = [...actions]
  _actions.splice(_actions.length, 0, info)

  _rid = { ..._rid, actions: _actions }
  _byid = { ..._byid, [`${info.reportId}`]: _rid }
  _data = { ..._data, byid: _byid }
  _actives = { ..._actives, data: _data }
  _state = { ..._state, actives: _actives }

  return _state
}

function _reports_archived_fulfilled(state, info) {
  let i = __reports_archived_normalized(info)
  let { archived, ..._state } = state
  let { data, pagination, ..._archived } = archived

  let pCount = Math.ceil(i.total / pagination.itemPerPage);
  if (pCount < 1) pCount = 1;
  pagination = {
    ...pagination,
    count: i.total,
    total: i.total,
    pageCount: pCount
  }

  let { byid, list, ..._data } = data

  let _byid = { ...byid, ...i.reports.byid }

  let _list = [...list]
  if (list.length < 1 || pagination.total !== i.total) {
    _list = new Array(pagination.total).fill(-1)
  }
  _list.splice(i.skip, i.reports.list.length, ...i.reports.list)

  _data = { ..._data, byid: _byid, list: _list }
  _archived = { ..._archived, data: _data, pagination: pagination }
  _state = { ..._state, archived: _archived }

  return _state
}
function _reports_archived_itemperpage(state, count) {
  let { archived, ..._state } = state
  let { pagination, ..._archived } = archived

  let pCount = Math.ceil(pagination.total / count);
  if (pCount < 1) pCount = 1;
  let _pagination = {
    ...pagination,
    itemPerPage: count,
    pageCount: pCount,
    currentPage: 1
  }

  _archived = {
    ..._archived,
    pagination: _pagination
  }
  _state = {
    ..._state,
    archived: _archived
  }
  return _state
}
function _reports_archived_currentPage(state, page) {
  let { archived, ..._state } = state
  let { pagination, ..._archived } = archived
  let _pagination = {
    ...pagination,
    currentPage: page
  }

  _archived = {
    ..._archived,
    pagination: _pagination
  }
  _state = {
    ..._state,
    archived: _archived
  }
  return _state
}

function __reports_active_normalized(actives) {
  let { reports, ..._actives } = actives
  let _reports = {
    byid: {},
    list: []
  }
  reports.forEach(r => {
    _reports.list.push(r.id)
    _reports.byid[r.id] = r
  })
  _actives = { ..._actives, reports: { ..._reports } }
  return _actives
}
function __reports_archived_normalized(archived) {
  let { reports, ..._archived } = archived
  let _reports = {
    byid: {},
    list: []
  }
  reports.forEach(r => {
    _reports.list.push(r.id)
    _reports.byid[r.id] = r
  })
  _archived = { ..._archived, reports: { ..._reports } }
  return _archived
}
function _reports_unarchived_fulfilled(state, info) {
  let rptId = info.report.id
  let { archived, actives, ..._state } = state
  let { data, pagination, ..._archived } = archived
  let { byid, list, ..._data } = data

  if (!byid[`${rptId}`]) {
    return state
  }

  /*eslint-disable no-unused-vars*/
  let { [`${rptId}`]: rpt, ..._byid } = byid
  /*eslint-enable no-unused-vars*/
  let _list = list.filter(e => e !== rptId)
  _data = { ..._data, byid: _byid, list: _list }

  let total = pagination.total - 1
  let pageCount = Math.ceil(total / pagination.itemPerPage)
  if (pageCount < 1) pageCount = 1;

  let currentPage = pagination.currentPage
  if (currentPage > pageCount) {
    currentPage = pageCount
  }
  let _pagination = {
    ...pagination,
    currentPage: currentPage,
    pageCount: pageCount,
    total: pagination.total - 1
  }
  _archived = { ..._archived, data: _data, pagination: _pagination }



  _state = {
    ..._state, archived: _archived, actives: {
      data: {
        byid: {},
        list: [],
      },
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      }
    }
  }
  return _state;
}




// WEBPACK FOOTER //
// ./src/redux/reducers/_reports.js